module.exports = __webpack_public_path__ + "media/images/flags/bh-f75f5a7f7eb6025fadfcaac50a05e2d1.svg";